// 통계 추출 메뉴 노출 판단 (화면용)
//
// 실제 허용 여부는 서버(usp_app_addStudyExportLog)가 연구 참여 정보로 판정한다.
// 여기서는 메뉴를 눌러도 거부될 사람에게 메뉴를 보여주지 않는 정도만 한다.
//   · 빌더 연구만 (추출 SP 가 빌더 연구 구조 기준)
//   · 시스템 관리자(UserType 'S') 또는 직책이 Investigator(DutyID 1) · CRA(DutyID 3)
//     (InfoDuty: 1 = Investigator, 2 = CRC, 3 = CRA)

import { isTruthyFlag } from './sourceIndex';

export const EXPORT_DUTY_IDS = [1, 3];

// 연구 창 토큰(SubjectView 와 같은 키)에 담긴 IsBuilderStudy 로 빌더 연구인지 판단한다.
// 토큰이 없거나 읽을 수 없으면 false — 통계 화면은 빌더 연구에서만 연다.
export function isBuilderStudyToken(token, storages = [localStorage, sessionStorage]) {
  if (!token) return false;
  for (const prefix of ['study-token-', 'subject-token-']) {
    for (const storage of storages) {
      const raw = storage?.getItem(`${prefix}${token}`);
      if (!raw) continue;
      try {
        return isTruthyFlag(JSON.parse(raw)?.IsBuilderStudy);
      } catch {
        return false;
      }
    }
  }
  return false;
}

export function canSeeStatisticsMenu(user, isBuilderStudy) {
  if (!isTruthyFlag(isBuilderStudy)) return false;
  if (!user) return false;
  if (user.UserType === 'S') return true;
  return EXPORT_DUTY_IDS.includes(Number(user.DutyID));
}

// 양식 관리 탭 (추출 템플릿 편집) — 관리자 · 그 연구 CRA (직책 CRA 또는 연구의 CRAID)
// 실제 허용 여부는 서버(usp_app_add/put/delStudyExportTemplate)가 다시 판정한다.
export const CRA_DUTY_ID = 3;

export function isExportAdmin(user) {
  return user?.UserType === 'S';
}

export function canEditExportTemplates(user, craId = null) {
  if (!user) return false;
  if (isExportAdmin(user)) return true;
  if (Number(user.DutyID) === CRA_DUTY_ID) return true;
  return craId !== null && craId !== undefined && craId !== '' && String(craId) === String(user.SystemUserID);
}
